module.exports = __webpack_public_path__ + "static/media/xlsx.b1bb01d6.svg";